/**
 * Puzzly plan configuration — single source of truth for tier caps + pricing.
 *
 * Slot model (Phase 7): users have a pool of ACTIVE_SLOTS concurrent puzzles.
 * Free = 3 slots, Pro = 30 slots. purchasedExtraSlots (deferred) can expand
 * the limit beyond the base. No rolling-window or per-theme caps.
 *
 * To retune: edit ACTIVE_SLOTS below. The client UX, paywall copy, and
 * Firestore Rules all derive from these numbers.
 *
 * NOTE: `plan` (monthly|yearly) is written to users/{uid}.entitlements.plan by
 * the server when a store purchase lands. entitlements.pro controls slot access.
 */

// Active-puzzle slot limits — the gate for create/delete.
export const ACTIVE_SLOTS = { free: 3, pro: 30 };

/**
 * Effective slot limit for a user profile.
 * BASE = free:3 / pro:30. purchasedExtraSlots defaults to 0 (pack deferred).
 *
 * @param {object} profile — users/{uid} doc snapshot; tolerates undefined / {}.
 * @returns {number}
 */
export function activeLimit(profile) {
  const isPro = profile?.entitlements?.pro === true;
  const base = isPro ? ACTIVE_SLOTS.pro : ACTIVE_SLOTS.free;
  const extra = Number.isFinite(profile?.purchasedExtraSlots)
    ? profile.purchasedExtraSlots
    : 0;
  return base + extra;
}

// I prezzi NON stanno più qui: li espone `getProducts()` del servizio billing
// (src/services/billing). Arrivano dal prodotto dello store e cambiano per paese:
// cablarli qui significherebbe mostrarne uno diverso da quello che l'utente paga.
